export enum EStatus {
  // Application statuses
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  DRAFT = 'DRAFT',
  QUERIED = 'QUERIED',
  SUBMITTED = 'SUBMITTED',
  RESUBMITTED = 'RESUBMITTED',
  UNDER_REVIEW = 'UNDER_REVIEW',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  SUSPENDED = 'SUSPENDED',
  PAID = 'PAID',
  UNPAID = 'UNPAID',
  OVERDUE = 'OVERDUE',
  REFUNDED = 'REFUNDED',
  FAILED = 'FAILED',
  UNKNOWN = 'UNKNOWN',
  PENDING_REGISTRY_APPROVAL = 'PENDING_REGISTRY_APPROVAL',
  PENDING_KYC_APPROVAL = 'PENDING_KYC_APPROVAL',
  KYC_REJECTED = 'KYC_REJECTED',
  PENDING_FIRST_REGISTRY_APPROVAL = 'PENDING_FIRST_REGISTRY_APPROVAL',
  FIRST_REGISTRY_QUERIED = 'FIRST_REGISTRY_QUERIED',
  PENDING_SECOND_REGISTRY_APPROVAL = 'PENDING_SECOND_REGISTRY_APPROVAL',
  SECOND_REGISTRY_QUERIED = 'SECOND_REGISTRY_QUERIED',
  PENDING_REGISTRAR_APPROVAL = 'PENDING_REGISTRAR_APPROVAL',
  REGISTRAR_QUERIED = 'REGISTRAR_QUERIED',
  FINALLY_APPROVED = 'FINALLY_APPROVED',
  FINALLY_REJECTED = 'FINALLY_REJECTED',
  REGISTRY_RECOMMENDED = 'REGISTRY_RECOMMENDED',
  AWAITING_OFFICE_CONFIRMATION = 'AWAITING_OFFICE_CONFIRMATION',
  PENDING_VERIFICATION = 'PENDING_VERIFICATION',
  PARTIALLY_APPROVED = 'PARTIALLY_APPROVED',
  PARTIALLY_REVIEWED = 'PARTIALLY_REVIEWED',
  PAYMENT_PENDING = 'PAYMENT_PENDING',
  DORMANT = 'DORMANT',
  SERVICE_ACCEPTED = 'SERVICE_ACCEPTED',
  SERVICE_REJECTED = 'SERVICE_REJECTED',
  USED = 'USED',
  PENDING_REVIEW = 'PENDING_REVIEW',
}


export const applicationStatuses =  [
  EStatus.FINALLY_APPROVED,
  EStatus.FINALLY_REJECTED,
  EStatus.UNDER_REVIEW,
  EStatus.QUERIED,
  EStatus.PENDING_REGISTRY_APPROVAL,
  EStatus.PENDING_REGISTRAR_APPROVAL,
  EStatus.PARTIALLY_APPROVED,
];

export const BusinessStatuses = [
  ...applicationStatuses,
  EStatus.PENDING_KYC_APPROVAL,
];

export const ClientStatuses = [
 ...applicationStatuses,
  EStatus.PENDING_KYC_APPROVAL,
  EStatus.KYC_REJECTED,
];

export const ReservedNameStatuses = [
  EStatus.APPROVED,
  EStatus.REJECTED,
  EStatus.PENDING,
];
